import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import ConstructionSharpIcon from "@mui/icons-material/ConstructionSharp";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import classes from "./ReportAProblem.module.css";
import TextField from "@mui/material/TextField";
import AsttButton from "components/AsttButton/AsttButton";
import { reportAproblem } from "services/centerPointUserServices";
import CircularProgress from "@mui/material/CircularProgress";
import SnackBar from "components/SnackBar/SnackBar";
import InfoModal from "components/CenterPoint/InfoModal/InfoModal";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import applicationUsageLog from "../../utils/applicationUsagesLog"

export default function ReportAProblem(props) {
  const { state, handleClose } = props;
  const [open, setOpen] = React.useState(false);
  const [issueType, setIssueType] = React.useState("");
  const [comments, setComments] = React.useState("");
  const [error, setError] = React.useState(false);
  const [isClicked, setIsClicked] = React.useState(false);
  const [infoModal, setInfoModal] = React.useState({
    state: false,
    header: "",
    message: "",
    icon: <CheckCircleSharpIcon className={classes.icon} />,
  });
  const issueTypes = [
    "Doesn't Work",
    "Doesnt Work correctly",
    "Something is slow",
    "Access issue",
    "Others",
  ];
  const [loader, setLoader] = React.useState(false);
  const [snack, setSnack] = React.useState({
    open: false,
    message: "",
    severity: "",
  });
  
   const handleChange = (event) => {
    setIssueType(event.target.value);
  };

  const handleInfoClose = () => {
    setInfoModal((prev) => {
      return {
        ...prev,
        state: false,
      };
    });
  };

  React.useEffect(() => {
    setOpen(state);
  }, [state]);

  const resetValues = () => {
    setError(false);
    setIsClicked(false);
    setIssueType("");
    setComments("");
  };

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const errorHandler = (open, message, severity) => {
    setSnack({
      open: true,
      message: message,
      severity: severity,
    });
  };

  const handleCommentChange = (e) => {
   setComments(e.target.value);
   if(e.target.value >= 100) {
    setError(false);
   }
  }

  const onSubmit = async () => {
    if (!issueType || !comments) setError(true);
    else {
      applicationUsageLog(localStorage.getItem("User"),localStorage.getItem("EmailId"),"ASTT","Report Problem");
      setError(false);
      const payload = {
        short_description: issueType,
        description: comments,
      };
      try {
        setLoader(true);
        setIsClicked(true);
        const response = await reportAproblem(payload);
        if (response?.data?.status) {
          setInfoModal((prev) => {
            return {
              ...prev,
              state: true,
              message: response.data.message,
              header: "Success",
            };
          });
          handleClose();
          resetValues();
        } else errorHandler(true, "Problem could not be reported !", "error");
      } catch (error) {
        errorHandler(true, "Something went wrong !", "error");
      } finally {
        setLoader(false);
      }
    }
  };

  return (
    <>
      {loader ? (
        <div className={classes.loader}>
          <CircularProgress sx={{ color: "#A8A8A8" }} />
        </div>
      ) : null}
      <InfoModal
        open={infoModal.state}
        message={infoModal.message}
        header={infoModal.header}
        icon={infoModal.icon}
        handleClose={handleInfoClose}
      />
      <Modal
        open={open}
        onClose={() => {
          resetValues();
          handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box className={classes.modalContainer}>
          <div className={classes.container}>
            <h2 className={classes.header}>
              <ConstructionSharpIcon /> Report a problem
            </h2>
            <CloseIcon
              onClick={() => {
                resetValues();
                handleClose();
              }}
              className={classes.closeIcon}
            />
          </div>
          <Grid container spacing={2} className={classes.gridContainer}>
            <Grid item xs={12}>
              <h3 className={classes.heading}>User Details</h3>
            </Grid>
            <Grid item xs={6}>
              <p className={classes.label}>Employee Name</p>
            </Grid>
            <Grid item xs={6}>
              <p className={classes.label}>Employee Oracle ID</p>
            </Grid>
            <Grid item xs={6}>
              <p className={classes.info}>{localStorage.getItem("User")}</p>
            </Grid>
            <Grid item xs={6}>
              <p className={classes.info}>{localStorage.getItem("OracleId")}</p>
            </Grid>
          </Grid>
          <Grid container spacing={2} className={classes.issueContainer}>
            <Grid item xs={12}>
              <h3 className={classes.heading}>Issue Details</h3>
            </Grid>
            <Grid item xs={6}>
              <p className={classes.label}>Issue Type</p>
            </Grid>
            <Grid item xs={6}>
              {" "}
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth className={classes.paddingRight}>
                <InputLabel id="demo-simple-select-label">
                  Select issue type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={issueType}
                  label="Select issue type"
                  onChange={handleChange}>
                  {issueTypes.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}></Grid>
            <Grid item xs={12}>
              <p className={classes.label}>Comment</p>
              <TextField
                id="outlined-multiline-flexible"
                placeholder="4000 Character Limit"
                multiline
                rows={4}
                value={comments}
                onChange={handleCommentChange}
                helperText={
                  <span className={
                    comments.length > 0 && comments.length < 100 ? classes.helperText : classes.helperTextValid}>
                    Please describe in at least 100 characters
                  </span>
                }
                className={classes.textField}
              />
            </Grid>
            {error && (
              <p className={classes.error}>
                Please enter all the fields before submiting !
              </p>
            )}
            <Grid item xs={12}>
              <AsttButton onClick={onSubmit} 
              disabled={comments.length < 100 || isClicked}>
                Submit
              </AsttButton>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </>
  );
}
